import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dark-bg">
        <div className="text-gray-400">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Preserve current path + query params so login can redirect back
    const fullPath = location.pathname + location.search;
    const redirectTo = location.pathname !== '/' ? `/login?next=${encodeURIComponent(fullPath)}` : '/login';
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
